// extracted by mini-css-extract-plugin
export default {"container":"KanbanBoard_container__vyCpg"};